import { useCallback } from "react";

/**
 * 处理后端推送的 "today_you_card" WebSocket 消息（手术 3：今日你叙事卡片）。
 *
 * 设计哲学（拉式入口，不打扰）：
 *   - 收到卡片时把它入栈到 todayYouCards（最新在前），并设 hasUnreadTodayYou=true
 *   - 不弹窗、不进聊天流、不打断学生当前思路
 *   - GUI 顶部 XP 条旁出现一个轻提示点，学生主动点入"我的成长中心 → 我的故事"才看到
 */
const useWsTodayYouHandler = ({ setTodayYouCards, setHasUnreadTodayYou }) => {
  return useCallback(
    (data) => {
      if (data.type !== "today_you_card") return false;
      try {
        let payload = data.payload;
        if (typeof payload === "string") payload = JSON.parse(payload);
        if (!payload || !payload.narrative) {
          console.warn("[TodayYou] 收到空卡片，忽略", payload);
          return true;
        }
        setTodayYouCards((prev) => {
          // 去重：相同 id 已存在则覆盖
          const filtered = (prev || []).filter((c) => c.id !== payload.id);
          return [payload, ...filtered];
        });
        setHasUnreadTodayYou(true);
        console.log("[TodayYou] 收到新卡片", payload);
      } catch (e) {
        console.error("[TodayYou] 处理卡片失败:", e);
      }
      return true;
    },
    [setTodayYouCards, setHasUnreadTodayYou]
  );
};

export default useWsTodayYouHandler;
